<section class="panel popup-panel panel-help" [@onSidePanelStatusChange]="statusPanel" (onClickOutside)="closePanel()">
  <mat-list class="custom-mat-list list-navigation">
    <a mat-list-item href="https://app.rebillia.com" target="_blank" class="custom-mat-link nav-option">
      <mat-icon svgIcon="ico-help-doc" class="custom-mat-icon ico-preffix ico-size ico-1xs"></mat-icon>
      Help Documentation
    </a>
    <a mat-list-item href="https://app.rebillia.com" target="_blank" class="custom-mat-link nav-option">
      <mat-icon svgIcon="ico-help-api" class="custom-mat-icon ico-preffix ico-size ico-1xs"></mat-icon>
      API Reference</a>
    <a mat-list-item href="https://app.rebillia.com" target="_blank" class="custom-mat-link nav-option">
      <mat-icon svgIcon="ico-help-faq" class="custom-mat-icon ico-preffix ico-size ico-1xs"></mat-icon>
      Knowledge Base/FAQs</a>
    <a mat-list-item class="custom-mat-link nav-option">
      <mat-icon svgIcon="ico-help-contactus" class="custom-mat-icon ico-preffix ico-size ico-1xs"></mat-icon>
      Write to us</a>
    <a mat-list-item class="custom-mat-link nav-option">
      <mat-icon svgIcon="ico-help-callback" class="custom-mat-icon ico-preffix ico-size ico-1xs"></mat-icon>
      Request a call</a>
  </mat-list>
</section>